export const SEARCH_LAYOUT_VARIATION = {
  dashboard: 'Dashboard',
  header: 'Global Header',
};
